export const RELEASE_DETAILS = {
  releaseNumber: '0.1.6',
  releaseXXDate: 'Tuesday, 5 April 2022, 14:11',
};
